import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { SelectValue } from 'antd/lib/select';

const { Option } = Select;

type ServiceStatusFilterProps = {
  onStatusUpdate: (value: string) => void;
};

const ServiceStatusFilter: React.FC<ServiceStatusFilterProps> = ({ onStatusUpdate }) => {
  const [filterValue, setFilterValue] = useState<string>('-1');

  const serviceStatusOptions = [
    { label: 'Service Status (All)', value: '-1' },
    { label: 'Enabled', value: 'true' },
    { label: 'Disabled', value: 'false' },
  ];

  const onServiceStatusFilterChange = (value: SelectValue) => {
    if (value === undefined) {
      setFilterValue('-1');
      onStatusUpdate('-1');
    } else {
      const newValue = String(value);
      setFilterValue(newValue);
      onStatusUpdate(newValue);
    }
  };

  useEffect(() => {
    onStatusUpdate(filterValue);
  }, []);

  return (
    <div>
      <Select
        placeholder="Service Status"
        onChange={onServiceStatusFilterChange}
        value={filterValue}
        showArrow={true}
        allowClear
      >
        {serviceStatusOptions.map((option) => (
          <Option value={option.value} key={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default ServiceStatusFilter;
